/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignBottom: {
  name: 'align-bottom';
  data: string;
} = {
  name: 'align-bottom',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 3a1 1 0 1 0-2 0v11.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 14.586V3ZM4 20a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Z" fill="currentColor"/></svg>`,
};
